import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../services/api";
import { setToastOk } from "../main/mainSlice";

const initialState = {
  admins: undefined,
  adminDetail: undefined,
  currentPage: 1,
  itemsPerPage: 10,
  totalPages: 0,
  query: {},
};

export const fetchAdmins = createAsyncThunk(
  "admins/fetchAdmins",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      var query = "";
      Object.keys(data).forEach((key) => {
        if (data[key]) {
          if (query !== "") {
            query += `&`;
          }
          query += `${key}=${data[key]}`;
        }
      });
      const response = await api.get(`/admins/search?${query}`);
      return response.data;
    } catch (error) {
      dispatch(
        setToastOk({
          isOk: false,
          messages: error.response.data,
        }),
      );
      return rejectWithValue(error.response.data);
    }
  },
);

export const fetchAdminDetail = createAsyncThunk(
  "admins/fetchAdminDetail",
  async ({ _id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`/admins/${_id}`);
      return response.data.data;
    } catch (error) {
      dispatch(
        setToastOk({
          isOk: false,
          messages: error.response.data,
        }),
      );
      return rejectWithValue(error.response.data);
    }
  },
);

export const createAdmin = createAsyncThunk(
  "admins/createAdmin",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(`/admins`, payload);
      dispatch(
        setToastOk({
          isOk: true,
          messages: response.data.message,
        }),
      );

      return response.data.data;
    } catch (error) {
      dispatch(
        setToastOk({
          isOk: false,
          messages: error.response.data,
        }),
      );
      return rejectWithValue(error.response.data);
    }
  },
);

export const editAdmin = createAsyncThunk(
  "admins/editAdmin",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.patch(`/admins/${payload._id}`, payload);
      dispatch(
        setToastOk({
          isOk: true,
          messages: response.data.message,
        }),
      );

      return response.data;
    } catch (error) {
      dispatch(
        setToastOk({
          isOk: false,
          messages: error.response.data,
        }),
      );
      return rejectWithValue(error.response.data);
    }
  },
);

export const deleteAdmin = createAsyncThunk(
  "admins/deleteAdmin",
  async ({ adminsId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.delete(`/admins/${adminsId}`);
      dispatch(
        setToastOk({
          isOk: true,
          messages: response.data.message,
        }),
      );
      return response.data;
    } catch (error) {
      dispatch(
        setToastOk({
          isOk: false,
          messages: error.response.data,
        }),
      );
      return rejectWithValue(error.response.data);
    }
  },
);

export const adminsSlice = createSlice({
  name: "admins",
  initialState,
  reducers: {
    removeAdmin: (state, action) => {
      state.adminDetail = undefined;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setQuery: (state, action) => {
      state.query = action.payload;
    },
  },
  extraReducers: (admins) => {
    admins
      .addCase(fetchAdmins.pending, (state) => {})
      .addCase(fetchAdmins.fulfilled, (state, action) => {
        state.admins = action.payload.data;
        state.totalPages = action.payload.pagination.totalPages;
      })
      .addCase(fetchAdmins.rejected, (state, action) => {})
      .addCase(fetchAdminDetail.pending, (state) => {})
      .addCase(fetchAdminDetail.fulfilled, (state, action) => {
        state.adminDetail = action.payload;
      })
      .addCase(fetchAdminDetail.rejected, (state, action) => {})
      .addCase(createAdmin.pending, (state) => {})
      .addCase(createAdmin.fulfilled, (state, action) => {
        state.admins = state.admins
          ? [action.payload, ...state.admins]
          : [action.payload];
      })
      .addCase(createAdmin.rejected, (state, action) => {})
      .addCase(editAdmin.pending, (state) => {})
      .addCase(editAdmin.fulfilled, (state, action) => {
        const editedAdmin = action.payload;
        state.admins?.forEach((admin) => {
          if (admin._id === editedAdmin._id) {
            Object.keys(admin).forEach((key) => {
              admin[key] = editedAdmin[key];
            });
          }
        });
      })
      .addCase(editAdmin.rejected, (state, action) => {})
      .addCase(deleteAdmin.pending, (state) => {})
      .addCase(deleteAdmin.fulfilled, (state, action) => {
        const deletedId = action.payload._id;
        state.admins = state.admins?.filter((admin) => admin._id !== deletedId);
      })
      .addCase(deleteAdmin.rejected, (state, action) => {});
  },
});

export const { removeAdmin, setCurrentPage, setQuery } = adminsSlice.actions;

export default adminsSlice.reducer;
